import React, { useState, useRef } from "react";
import { Play } from "lucide-react";

const DemoSection = () => {
  const [playingDemo, setPlayingDemo] = useState(false);
  const [videoLoaded, setVideoLoaded] = useState(false);
  const iframeRef = useRef(null);

  const handleThumbnailClick = () => {
    setPlayingDemo(true);
  };

  return (
    <>
      {!playingDemo ? (
        <div
          onClick={handleThumbnailClick}
          className="relative cursor-pointer group"
          style={{ aspectRatio: "1.75253807106599" }}
        >
          {/* Inline SVG thumbnail */}
          <div className="absolute inset-0 flex items-center justify-center bg-gradient-to-r from-blue-50 to-indigo-50">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 800 456"
              className="w-full h-full"
            >
              {/* Background gradient */}
              <defs>
                <linearGradient
                  id="bgGradient"
                  x1="0%"
                  y1="0%"
                  x2="100%"
                  y2="100%"
                >
                  <stop
                    offset="0%"
                    style={{ stopColor: "#EFF6FF", stopOpacity: 1 }}
                  />
                  <stop
                    offset="100%"
                    style={{ stopColor: "#EEF2FF", stopOpacity: 1 }}
                  />
                </linearGradient>
                <linearGradient
                  id="btnGradient"
                  x1="0%"
                  y1="0%"
                  x2="100%"
                  y2="100%"
                >
                  <stop
                    offset="0%"
                    style={{ stopColor: "#2563EB", stopOpacity: 1 }}
                  />
                  <stop
                    offset="100%"
                    style={{ stopColor: "#4F46E5", stopOpacity: 1 }}
                  />
                </linearGradient>
                <filter
                  id="shadow"
                  x="-20%"
                  y="-20%"
                  width="140%"
                  height="140%"
                >
                  <feDropShadow
                    dx="0"
                    dy="4"
                    stdDeviation="10"
                    floodColor="#0F172A"
                    floodOpacity="0.2"
                  />
                </filter>
              </defs>

              {/* Main background */}
              <rect
                width="800"
                height="456"
                fill="url(#bgGradient)"
                rx="12"
                ry="12"
              />

              {/* Receipt visualization */}
              <rect
                x="250"
                y="78"
                width="300"
                height="220"
                rx="8"
                ry="8"
                fill="white"
                filter="url(#shadow)"
              />

              {/* Receipt header */}
              <rect
                x="270"
                y="98"
                width="260"
                height="30"
                rx="4"
                ry="4"
                fill="#F1F5F9"
              />
              <rect
                x="280"
                y="108"
                width="180"
                height="10"
                rx="2"
                ry="2"
                fill="#94A3B8"
              />

              {/* Receipt items */}
              <rect x="270" y="138" width="260" height="1" fill="#E2E8F0" />
              <rect
                x="280"
                y="148"
                width="160"
                height="8"
                rx="2"
                ry="2"
                fill="#334155"
              />
              <rect
                x="480"
                y="148"
                width="40"
                height="8"
                rx="2"
                ry="2"
                fill="#334155"
              />

              <rect
                x="280"
                y="168"
                width="140"
                height="8"
                rx="2"
                ry="2"
                fill="#334155"
              />
              <rect
                x="480"
                y="168"
                width="40"
                height="8"
                rx="2"
                ry="2"
                fill="#334155"
              />

              <rect
                x="280"
                y="188"
                width="170"
                height="8"
                rx="2"
                ry="2"
                fill="#334155"
              />
              <rect
                x="480"
                y="188"
                width="40"
                height="8"
                rx="2"
                ry="2"
                fill="#334155"
              />

              <rect x="270" y="208" width="260" height="1" fill="#E2E8F0" />

              {/* Receipt totals */}
              <rect
                x="370"
                y="218"
                width="70"
                height="8"
                rx="2"
                ry="2"
                fill="#334155"
              />
              <rect
                x="480"
                y="218"
                width="40"
                height="8"
                rx="2"
                ry="2"
                fill="#64748B"
              />

              <rect
                x="370"
                y="238"
                width="70"
                height="8"
                rx="2"
                ry="2"
                fill="#334155"
              />
              <rect
                x="480"
                y="238"
                width="40"
                height="8"
                rx="2"
                ry="2"
                fill="#64748B"
              />

              <rect
                x="370"
                y="258"
                width="70"
                height="10"
                rx="2"
                ry="2"
                fill="#0F172A"
              />
              <rect
                x="480"
                y="258"
                width="40"
                height="10"
                rx="2"
                ry="2"
                fill="#0F172A"
              />

              {/* Spreadsheet visualization arrow */}
              <path
                d="M575 178 L635 178 L625 168 L635 178 L625 188"
                stroke="#2563EB"
                strokeWidth="3"
                fill="none"
              />

              {/* Spreadsheet visualization */}
              <rect
                x="645"
                y="118"
                width="120"
                height="120"
                rx="6"
                ry="6"
                fill="white"
                filter="url(#shadow)"
              />
              <rect
                x="655"
                y="128"
                width="100"
                height="20"
                rx="2"
                ry="2"
                fill="#F1F5F9"
              />
              <rect
                x="655"
                y="158"
                width="30"
                height="10"
                rx="2"
                ry="2"
                fill="#94A3B8"
              />
              <rect
                x="695"
                y="158"
                width="30"
                height="10"
                rx="2"
                ry="2"
                fill="#94A3B8"
              />
              <rect
                x="735"
                y="158"
                width="20"
                height="10"
                rx="2"
                ry="2"
                fill="#94A3B8"
              />

              <rect
                x="655"
                y="178"
                width="30"
                height="10"
                rx="2"
                ry="2"
                fill="#334155"
              />
              <rect
                x="695"
                y="178"
                width="30"
                height="10"
                rx="2"
                ry="2"
                fill="#334155"
              />
              <rect
                x="735"
                y="178"
                width="20"
                height="10"
                rx="2"
                ry="2"
                fill="#2563EB"
              />

              <rect
                x="655"
                y="198"
                width="30"
                height="10"
                rx="2"
                ry="2"
                fill="#334155"
              />
              <rect
                x="695"
                y="198"
                width="30"
                height="10"
                rx="2"
                ry="2"
                fill="#334155"
              />
              <rect
                x="735"
                y="198"
                width="20"
                height="10"
                rx="2"
                ry="2"
                fill="#2563EB"
              />

              <rect
                x="655"
                y="218"
                width="30"
                height="10"
                rx="2"
                ry="2"
                fill="#334155"
              />
              <rect
                x="695"
                y="218"
                width="30"
                height="10"
                rx="2"
                ry="2"
                fill="#334155"
              />
              <rect
                x="735"
                y="218"
                width="20"
                height="10"
                rx="2"
                ry="2"
                fill="#2563EB"
              />

              {/* Camera icon with receipt */}
              <circle
                cx="135"
                cy="178"
                r="65"
                fill="white"
                filter="url(#shadow)"
              />
              <path
                d="M105 158 L165 158 L165 198 L105 198 Z"
                fill="#F1F5F9"
                stroke="#CBD5E1"
                strokeWidth="1"
              />
              <path
                d="M115 168 L155 168 L155 188 L115 188 Z"
                fill="white"
                stroke="#CBD5E1"
                strokeWidth="1"
              />
              <rect
                x="120"
                y="173"
                width="30"
                height="2"
                rx="1"
                ry="1"
                fill="#94A3B8"
              />
              <rect
                x="120"
                y="178"
                width="25"
                height="2"
                rx="1"
                ry="1"
                fill="#94A3B8"
              />
              <rect
                x="120"
                y="183"
                width="28"
                height="2"
                rx="1"
                ry="1"
                fill="#94A3B8"
              />

              {/* Camera visualization arrow */}
              <path
                d="M200 178 L240 178 L230 168 L240 178 L230 188"
                stroke="#2563EB"
                strokeWidth="3"
                fill="none"
              />

              {/* Main Play button */}
              <circle
                cx="400"
                cy="228"
                r="50"
                fill="white"
                filter="url(#shadow)"
              />
              <circle cx="400" cy="228" r="45" fill="url(#btnGradient)" />
              <path d="M390 208 L420 228 L390 248 Z" fill="white" />

              {/* Title text */}
              <text
                x="400"
                y="340"
                fontFamily="Arial, sans-serif"
                fontSize="24"
                fontWeight="bold"
                textAnchor="middle"
                fill="#1E293B"
              >
                See How ExpenseBot Works
              </text>
              <text
                x="400"
                y="370"
                fontFamily="Arial, sans-serif"
                fontSize="16"
                textAnchor="middle"
                fill="#64748B"
              >
                Watch our interactive demo - click to play
              </text>
            </svg>
          </div>

          {/* Prominent play button overlay */}
          <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-20 group-hover:bg-opacity-30 transition-all">
            <div className="w-20 h-20 sm:w-24 sm:h-24 rounded-full bg-white shadow-lg flex items-center justify-center group-hover:scale-110 transition-transform">
              <Play className="w-10 h-10 sm:w-12 sm:h-12 text-blue-600 ml-1" />
            </div>
          </div>

          {/* Info text overlay at bottom */}
          <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-blue-900 to-transparent p-4">
            <h3 className="text-white font-medium text-lg">
              See how ExpenseBot makes expense tracking effortless
            </h3>
          </div>
        </div>
      ) : (
        <div className="relative" style={{ aspectRatio: "1.75253807106599" }}>
          {/* Loading indicator */}
          {!videoLoaded && (
            <div className="absolute inset-0 flex items-center justify-center bg-gray-100">
              <div className="animate-pulse text-gray-500">Loading demo...</div>
            </div>
          )}

          {/* New SupaDemo embed */}
          <iframe
            ref={iframeRef}
            src="https://app.supademo.com/embed/cm95c1zmy046wy80iek98elkp?embed_v=2"
            loading="lazy"
            title="ExpenseBot How To"
            allow="clipboard-write"
            frameBorder="0"
            webkitallowfullscreen="true"
            mozallowfullscreen="true"
            allowFullScreen
            className="absolute inset-0 w-full h-full"
            onLoad={() => setVideoLoaded(true)}
          />

          {/* New window button */}
          <button
            onClick={() =>
              window.open(
                "https://app.supademo.com/embed/cm95c1zmy046wy80iek98elkp?embed_v=2",
                "_blank"
              )
            }
            className="absolute top-2 right-2 bg-blue-600 hover:bg-blue-700 text-white rounded p-2 transition-all z-20 shadow-md"
            title="Open in new window"
            aria-label="Open demo in new window"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
              <polyline points="15 3 21 3 21 9"></polyline>
              <line x1="10" y1="14" x2="21" y2="3"></line>
            </svg>
          </button>
        </div>
      )}
    </>
  );
};

export default DemoSection;
